export const TEMPLATES = [
  {
    fullType: "blank",
    type: "blank",
    content: ``,
  },
  {
    fullType: "v1_oneoftwo",
    type: "oneoftwo",
    content: `version: 1
type: oneoftwo
name: CHANGE_ME
level: CHANGE_ME
questions:
  - meta:
      text: Complete the sentence with **This** or **That**
      translation: Закінчи речення з **Це** чи **То**
      assignment: |
        (**This** or **That**) is a book
    variants:
      - This
      - That
    correct: 1
  - meta:
      text: Complete the sentence with **This** or **That**
      translation: Закінчи речення з **Це** чи **То**
      assignment: |
        (**This** or **That**) is a bag
    variants:
      - This
      - That
    correct: 1
`,
  },
  {
    fullType: "v1_oneofthree",
    type: "oneofthree",
    content: `version: 1
type: oneofthree
name: CHANGE_ME
level: CHANGE_ME
questions:
  - meta:
      text: Learn the words
      translation: Вивчи слова
      assignment: |
        **mole** - кріт
    variants:
      - Next
    correct: 0
  - meta:
      text: Learn the words
      translation: Вивчи слова
      assignment: |
        **rope** - канат
    variants:
      - Next
    correct: 0
`,
  },
  {
    fullType: "v1_input",
    type: "input",
    content: `version: 1
type: input
name: CHANGE_ME
level: CHANGE_ME
questions:
  - meta:
      text: Type the missing word in
      translation: Впиши слово, якого невистачає
      assignment: |
        fall - fell - ... - падати
    correct: fallen
  - meta:
      text: Type the missing word in
      translation: Впиши слово, якого невистачає
      assignment: |
        feel -  ... - felt - відчувати
    correct: felt
`,
  },
  {
    fullType: "v1_order · words",
    type: "order",
    content: `version: 1
type: order
unit: word
name: CHANGE_ME
level: CHANGE_ME
questions:
  - meta:
      text: Put the words in the correct order
      translation: Постав слова у правильному порядку
      assignment:
    variants:
      - have
      - they
      - got
      - glasses
    correct: they have got glasses
`,
  },
  {
    fullType: "v1_order · letters (spell)",
    type: "order",
    content: `version: 1
type: order
unit: letter
name: CHANGE_ME
level: CHANGE_ME
questions:
  - meta:
      text: Spell the word
      translation: кіт
      assignment:
    variants:
      - t
      - c
      - a
    correct: cat
`,
  },
  {
    fullType: "v2_input",
    type: "input",
    content: `version: 2
type: input
name: CHANGE_ME
level: CHANGE_ME # A0, A1, A1+, A2, B1, B2, C1
questions:
  - meta:
      text: |
        Write down the translation
      translation: Впиши переклад англійською мовою
      assignment: |

        1. субота - [()]
        1. бейсбол - [()]

    correct:

      - saturday
      - baseball
`,
  },
  {
    fullType: "v2_theory",
    type: "theory",
    content: `version: 2
type: theory
name: CHANGE_ME
level: CHANGE_ME
content: |

  REPLACE_ME
`,
  },
  {
    fullType: "v2_matchselect",
    type: "matchselect",
    content: `version: 2
type: matchselect
name: CHANGE_ME
level: CHANGE_ME
questions:
  - meta:
      text: |
        Insert the missing letter
      translation: Встав пропущену літеру

      assignment: |
        1. c[(-)]p - кепка
        1. [(-)]loves - перчатки

      variants:
        - a
        - s

    correct:
      - a
      - g
`,
  },
  {
    fullType: "v2_radio",
    type: "radio",
    content: `version: 2
type: radio
name: CHANGE_ME
level: CHANGE_ME
meta:
  text: Find the translation
  translation: Знайди переклад
questions:
  - meta:
      assignment: |
        четвер
    variants:
      - Monday
      - Thursday
      - tennis
    correct: 1
  - meta:
      assignment: |
        теніс
    variants:
      - Monday
      - Thursday
      - tennis
    correct: 2
`,
  },
  {
    fullType: "v2_radioinline",
    type: "radioinline",
    content: `version: 2
type: radioinline
name: CHANGE_ME
level: CHANGE_ME
questions:
  - meta:
      text: |
        Choose **have** or **has**
      translation:

      assignment: |
        1. I [(have, has)] got a head - **в мене є голова**
        1. She [(have, has)] got 2 shoulders - **в неї є 2 плеча**

    correct:
      - have
      - has
`,
  },
  {
    fullType: "v2_wordcards",
    type: "wordcards",
    content: `version: 2
type: wordcards
name: CHANGE_ME
level: CHANGE_ME
questions:
  - [[[huge]]]
  - [[[scientist]]]
`,
  },
  {
    // Memo — matching-memory companion to WordCards. Same data shape
    // (`questions` is a list of `<word>` tags resolved from vocabulary),
    // different runner. `pairs` is optional — when omitted, the runner
    // deals `min(8, len(questions))`. The author can pin a smaller deck
    // for shorter lessons or a larger one if their vocabulary bank has
    // the headroom.
    fullType: "v2_memo",
    type: "memo",
    content: `version: 2
type: memo
name: CHANGE_ME
level: CHANGE_ME
pairs: 6
questions:
  - [[[huge]]]
  - [[[scientist]]]
  - [[[atmosphere]]]
  - [[[gravity]]]
  - [[[magnet]]]
  - [[[particle]]]
`,
  },
  {
    // Match — the third runner over the same word pack: two columns, tap a
    // word then its translation. No `pairs` knob (unlike memo): the runner
    // plays the whole list, four pairs to a round, so the word count is the
    // length of the game. It is also the only one of the three that grades —
    // a word mis-paired at least once counts wrong — so the pack length is
    // what the student's score is out of.
    fullType: "v2_match",
    type: "match",
    content: `version: 2
type: match
name: CHANGE_ME
level: CHANGE_ME
questions:
  - [[[huge]]]
  - [[[scientist]]]
  - [[[atmosphere]]]
  - [[[gravity]]]
  - [[[magnet]]]
  - [[[particle]]]
`,
  },
  {
    fullType: "v2_multichoice",
    type: "multichoice",
    content: `version: 2
type: multichoice
name: CHANGE_ME
level: CHANGE_ME
# Each top-level question is a PAGE: free-form markdown (text, images,
# <video src="...master.m3u8"></video>, an .mp3 link) plus its own questions.
# Every question may have more than one correct answer, so \`correct\` is a
# LIST of variant indices (0-based). Drop the second page for a one-pager.
#
# On a page, only \`questions\` is required. \`name\`, \`icon\`, \`content\` and
# \`assignment\` are all optional — delete any you don't want. A page with no
# \`name\` is just labelled "Сторінка N"; with one page the tab strip hides
# entirely, so \`name\`/\`icon\` are only worth writing for multi-page ones
# (the second page below leaves them out to show it).
questions:
  - meta:
      name: Читання
      icon: "📖"
      assignment: Прочитай історію та обери всі правильні відповіді.
      content: |
        #### Max and the rain

        Max is a small grey **cat**. He lives in a yellow house with Anna
        and her brother Tom.

        On Monday it rains all day. Max does not like the rain, so he sleeps
        on the warm windowsill and watches the drops.
      questions:
        - meta:
            assignment: What is true about Max?
          variants:
            - He is a cat
            - He is grey
            - He is big
            - He lives with Anna
          correct: [0, 1, 3]
        - meta:
            assignment: What does Max do on Monday?
          variants:
            - He plays in the garden
            - He sleeps on the windowsill
            - He watches the rain
            - He goes to school
          correct: [1, 2]
  - meta:
      content: |
        [Прослухати](CHANGE_ME.mp3)
      questions:
        - meta:
            assignment: What does the girl buy?
          variants:
            - Apples
            - Milk
            - Bread
            - Bananas
          correct: [0, 1, 3]
`,
  },
  {
    fullType: "v3_exam",
    type: "exam",
    content: `version: 3
type: exam
name: CHANGE_ME
level: CHANGE_ME
questions:
  - meta:
      type: radioinline
      name: CHANGE_ME
      questions:
        - meta:
            text: Read the text and choose the right option for each gap.
            translation:
            assignment: |
                ***Reading***

                ## Why Your ‘Weak-Tie’ Friendships May Mean More Than You Think


                For nearly 10 years, I have spent my Monday evenings attending rehearsals for my amateur choir. Mondays are not my favourite days, (1) [(A, B, C, D, E, F, G, H)], but by the end of the rehearsal, I usually feel energised. The singing does me good. So do the people.

                There is no choir practice now, and won’t be for a long time. I miss it. In lockdown, I don’t feel short of affection or emotional support, but I do feel short of friendly faces and casual conversations. Another way of putting this is (2) [(A, B, C, D, E, F, G, H)].
                ___________________________

                **A** but I don’t remember their names

                **B** that I miss my weak ties

                **C** that for new information and ideas

                **D** whom you spend a lot of time with

                **E** whom they saw only occasionally

                **F** but it has turned out that quantity matters

                **G** and I often arrive in a bad mood

                **H** whom you have never met before

          correct:
            - g
            - b

  - meta:
      type: radio
      meta:
        text: Vocabulary - find the translation
        translation: ""
        assignment: |
            ### Task 1 *Vocabulary*

            ## Feelings

            ![](https://cdn.icepig.online/media/assignments/busy_street_test.jpeg)
      questions:
        - meta:
            assignment: |
              upset
          variants:
            - засмучений
            - збентежений
            - самотній
          correct: 0
        - meta:
            assignment: |
              embarrassed
          variants:
            - самотній
            - знервований
            - зніяковілий
          correct: 2

  - meta:
      type: input
      name: CHANGE_ME
      questions:
        - meta:
            text: |
              Complete using the correct present simple form of the verbs in bracket
            translation: |
              Доповнити речення правильною формою дієслова в дужках
            assignment: |
              ## Present Simple

              ### Task 3

              1. My sister [(read)] a book.
              1. Frank [(like)] dogs.

          correct:
            - reads
            - likes

  - meta:
      type: matchselect
      name: CHANGE_ME
      # One pool for the whole section — every gap below picks from it, and a
      # variant used in one gap is greyed out in the rest of this section.
      # (Unlike radio, whose variants sit on each sub-question.)
      variants:
        - a
        - g
        - o
        - c
      meta:
        text: Insert the missing letter
        translation: Встав пропущену літеру
      questions:
        - meta:
            assignment: |
              1. c[(-)]p — кепка
              1. [(-)]loves — рукавички
          correct:
            - a
            - g
        - meta:
            assignment: |
              1. s[(-)]ck — шкарпетка
              1. [(-)]oat — пальто
          correct:
            - o
            - c

  - meta:
      type: multichoice
      name: CHANGE_ME
      # Read/watch/listen, then pick EVERY true statement. Unlike radio, each
      # question can have several right answers — and unlike matchselect, the
      # variants belong to each question rather than to the section.
      #
      # An .mp3 link in the content renders as an audio player and an HLS link
      # as a video, so a listening section needs no special syntax.
      content: |
        ## The city that never sleeps

        New York has around 8 million residents. The subway runs all night,
        which is unusual — most metro systems close after midnight.
      questions:
        - meta:
            assignment: Which statements about New York are true?
          variants:
            - It has around 8 million residents.
            - The subway runs all night.
            - The subway closes after midnight.
            - It is the capital of the USA.
          # Indices into the variants above. At least one must be true and at
          # least one false: a question where everything is correct is aced
          # by ticking every box, so the validator rejects it.
          correct:
            - 0
            - 1
`,
  },
  {
    fullType: "v4_openquestion",
    type: "openquestion",
    content: `version: 4
type: openquestion
name: CHANGE_ME
level: CHANGE_ME
content: |

  REPLACE_ME
`,
  },
];
